module.exports = __webpack_public_path__ + "img/photo-0035.bf80ee17.jpg";